import { USER_ROLES } from "@/constants";
import { PHISH_SERVICE } from "@/utils/services";

export const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "email_security",
      name: "msp-email_security",
      component: () => import("@/modules/PhishTitan/views/Msp"),
      meta: {
        solutionId: PHISH_SERVICE,
      },
      redirect: {
        name: "msp-email_security-overview",
      },
      children: [
        {
          path: "overview",
          name: "msp-email_security-overview",
          component: () => import("@/modules/PhishTitan/views/Msp/Overview"),
          exact: false,
          meta: {
            authorize: [USER_ROLES.SYSTEM, USER_ROLES.SALES, USER_ROLES.MSP],
          },
        },
        {
          path: "reports",
          name: "msp-email_security-reports",
          exact: true,
          component: () => import("@/modules/PhishTitan/views/Msp/Reports"),
          redirect: {
            name: "insightsMspRoute",
          },
          children: [
            {
              path: "",
              name: "insightsMspRoute",
              component: () =>
                import("@/modules/PhishTitan/views/Msp/Reports/PowerBi"),
              redirect: {
                name: "summaryMspReport",
              },
              children: [
                {
                  path: "summary",
                  name: "summaryMspReport",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Msp/Reports/PowerBi/Summary"
                    ),
                },
                {
                  path: "insights",
                  name: "insightsMspReport",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Msp/Reports/PowerBi/ThreatSurfaceReport"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "notifications",
          name: "msp-email_security-notifications",
          component: () =>
            import("@/modules/PhishTitan/views/Msp/Notifications/index.vue"),
        },
        {
          path: "configuration",
          name: "msp-email_security-configuration",
          exact: true,
          redirect: {
            name: "msp-configuration-mail-flow-remediation",
          },
          children: [
            {
              path: "mail_flow",
              name: "msp-configuration-mail-flow",
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Msp/Configuration/MailFlow/MailFlow.vue"
                ),
              exact: true,
              redirect: {
                name: "msp-configuration-mail-flow-remediation",
              },
              children: [
                {
                  path: "remediation",
                  name: "msp-configuration-mail-flow-remediation",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Common/Remediation/index.vue"
                    ),
                },
                {
                  path: "exploited_domains",
                  name: "msp-configuration-mail-flow-exploited-domains",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Common/ExploitedDomains/index.vue"
                    ),
                },
                {
                  path: "anti_spoofing",
                  name: "msp-configuration-mail-flow-anti-spoofing",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Common/AntiSpoofing/AntiSpoofing.vue"
                    ),
                },
                {
                  path: "graymail",
                  name: "msp-configuration-mail-flow-graymail",
                  component: () =>
                    import(
                      "@/modules/PhishTitan/views/Common/Graymail/Graymail.vue"
                    ),
                },
              ],
            },
            {
              path: "link_lock",
              name: "msp-email_security-config-link-lock",
              exact: true,
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Msp/Configuration/LinkLock/index.vue"
                ),
            },
          ],
        },
        {
          path: "incidents",
          name: "msp-email_security-incidents",
          component: () =>
            import("@/modules/PhishTitan/views/Msp/Incidents/Overview"),
        },
        {
          path: "incidents/incident_summary",
          name: "msp-email_security-incidents-incident-summary",
          component: () =>
            import(
              "@/modules/PhishTitan/views/Msp/Incidents/IncidentSummary/IncidentSummary.vue"
            ),
          redirect: {
            name: "msp-email_security-incidents-incident-summary-details",
          },
          children: [
            {
              path: "details",
              name: "msp-email_security-incidents-incident-summary-details",
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Msp/Incidents/IncidentSummary/Details"
                ),
            },
            {
              path: "threat-coach",
              name: "msp-email_security-incidents-incident-summary-threat-coach",
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Common/Incidents/IncidentSummary/ThreatCoach/ThreatCoach"
                ),
            },
            {
              path: "affected-users",
              name: "msp-email_security-incidents-incident-summary-affected-users",
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Msp/Incidents/IncidentSummary/AffectedUsers"
                ),
            },
            {
              path: "received-headers",
              name: "msp-email_security-incidents-incident-summary-received-headers",
              component: () =>
                import(
                  "@/modules/PhishTitan/views/Msp/Incidents/IncidentSummary/ReceivedHeaders"
                ),
            },
            {
              path: "timeline",
              name: "msp-email_security-incidents-incident-summary-received-timeline",
              redirect: {
                name: "msp-email_security-incidents-incident-summary-details",
              },
            },
            {
              path: "timeline",
              name: "msp-email_security-incidents-incident-summary-incident-timeline",
              redirect: {
                name: "msp-email_security-incidents-incident-summary-details",
              },
            },
            {
              path: "audit-logs",
              name: "msp-email_security-incidents-incident-summary-audit-logs",
              redirect: {
                name: "msp-email_security-incidents-incident-summary-details",
              },
            },
            {
              path: "notes",
              name: "msp-email_security-incidents-incident-summary-audit-notes",
              redirect: {
                name: "msp-email_security-incidents-incident-summary-details",
              },
            },
          ],
        },
      ],
    },
  ],
};

export default {};
